exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.instructions-icon {\n    font-size: .60em;\n    font-weight: bold;\n    color: #6c757d;\n}\n.instructions {\n    font-size: .90em;\n    font-style: italic;\n    font-weight: bold;\n    color: #6c757d;\n    position: relative;\n    top: 2px;\n}\n", ""]);

// exports
